// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'uz',
        interpolation: {
            escapeValue: false
        },
        resources: {
            uz: {
                translation: {
                    greeting: 'Assalomu alaykum, {{name}}',
                    searchPlaceholder: 'Mahsulot qidirish',
                    next: 'Keyingi',
                    prev: 'Oldingi',
                    loadingOrder: 'Buyurtma yuborilmoqda...',
                    successOrder: 'Buyurtma muvaffaqiyatli yuborildi!',
                    error: 'Xatolik',
                    refresh: 'Sahifani yangilash',
                    products: "Mahsulotlar",
                    addToCart: 'Savatga qo‘shish',
                    cartTitle: "Savatcha",
                    price: "Narx",
                    total: "Jami",
                    note: "Qisqa eslatma",
                    deliveryTime: "Yetkazish vaqti",
                    submitOrder: "Buyurtmani yuborish",
                    verificationCode: "Tasdiqlash kodi",
                    enterCodeInstruction: "Telegram bot orqali yuborilgan 4 xonali tasdiqlash kodini kiriting.",
                    cancel: "Bekor qilish",
                    verify: "Tasdiqlash",
                    verifying: "Tekshirilmoqda...",
                    codeLengthError: "Iltimos, 4 xonali kodni to‘liq kiriting",
                    verificationFailed: "Kod noto‘g‘ri yoki muddati tugagan",
                    orderSuccess: 'Buyurtma muvaffaqiyatli yuborildi!',
                    orderError: 'Xatolik: {{message}}',
                    orderSubmitError: 'Buyurtma yuborishda xatolik: {{message}}',
                    submittingOrder: 'Buyurtma yuborilmoqda...',
                    customerOrBranchNotFound: 'Mijoz yoki filial topilmadi!',
                    productsNotFound: 'Mahsulotlar topilmadi!',
                    dataLoadError: 'Ma\'lumotlarni yuklashda xatolik: {{message}}',
                    errorOccurred: 'Xatolik yuz berdi',
                    unknownError: 'Noma\'lum xatolik',
                    refreshPage: 'Sahifani yangilash',
                    previous: 'Oldingi',

                    paymentMethods: 'To‘lov usullari',
                    paymentMethod: 'To‘lov turi',
                    payOfflineLabel: '1. Naqd to‘lov',
                    payOfflineDesc: 'Kuryerga yoki kassaga to‘lang',
                    payWithClickLabel: '2. CLICK orqali to‘lov',
                    payWithClickDesc: 'Onlayn to‘lov (CLICK)',
                    payOffline: 'Naqd to‘lov',
                    payWithClick: 'CLICK orqali to‘lov',



                }
            },
            ru: {
                translation: {
                    greeting: 'Здравствуйте, {{name}}',
                    searchPlaceholder: 'Поиск товара',
                    next: 'Следующая',
                    prev: 'Предыдущая',
                    loadingOrder: 'Отправка заказа...',
                    successOrder: 'Заказ успешно отправлен!',
                    error: 'Ошибка',
                    refresh: 'Обновить страницу',
                    products: "Товары",
                    addToCart: 'Добавить в корзину',
                    cartTitle: "Корзина",
                    price: "Цена",
                    total: "Итого",
                    note: "Краткое примечание",
                    deliveryTime: "Время доставки",
                    submitOrder: "Отправить заказ",
                    verificationCode: "Код подтверждения",
                    enterCodeInstruction: "Введите 4-значный код, отправленный через Telegram-бот.",
                    cancel: "Отмена",
                    verify: "Подтвердить",
                    verifying: "Проверяется...",
                    codeLengthError: "Пожалуйста, введите полный 4-значный код",
                    verificationFailed: "Неверный код или срок действия истек",
                    orderSuccess: 'Заказ успешно отправлен!',
                    orderError: 'Ошибка: {{message}}',
                    orderSubmitError: 'Ошибка при отправке заказа: {{message}}',
                    submittingOrder: 'Отправка заказа...',
                    customerOrBranchNotFound: 'Клиент или филиал не найден!',
                    productsNotFound: 'Товары не найдены!',
                    dataLoadError: 'Ошибка загрузки данных: {{message}}',
                    errorOccurred: 'Произошла ошибка',
                    unknownError: 'Неизвестная ошибка',
                    refreshPage: 'Обновить страницу',
                    previous: 'Предыдущая',

                    paymentMethods: 'Способы оплаты',
                    paymentMethod: 'Тип оплаты',
                    payOfflineLabel: '1. Оплата наличными',
                    payOfflineDesc: 'Оплата курьеру или на кассе',
                    payWithClickLabel: '2. Оплата через Click',
                    payWithClickDesc: 'Онлайн-оплата (CLICK)',
                    payOffline: 'Оплата наличными',
                    payWithClick: 'Оплатить через Click',
                }
            },
            en: {
                translation: {
                    greeting: 'Hello, {{name}}',
                    searchPlaceholder: 'Search product',
                    next: 'Next',
                    prev: 'Previous',
                    loadingOrder: 'Submitting order...',
                    successOrder: 'Order submitted successfully!',
                    error: 'Error',
                    refresh: 'Refresh page',
                    products: "Products",
                    addToCart: 'Add to Cart',
                    cartTitle: "Cart",
                    price: "Price",
                    total: "Total",
                    note: "Note",
                    deliveryTime: "Delivery Time",
                    submitOrder: "Submit Order",
                    verificationCode: "Verification Code",
                    enterCodeInstruction: "Enter the 4-digit code sent via Telegram bot.",
                    cancel: "Cancel",
                    verify: "Verify",
                    verifying: "Verifying...",
                    codeLengthError: "Please enter the full 4-digit code",
                    verificationFailed: "Invalid code or expired",
                    orderSuccess: 'Order submitted successfully!',
                    orderError: 'Error: {{message}}',
                    orderSubmitError: 'Error while submitting order: {{message}}',
                    submittingOrder: 'Submitting order...',
                    customerOrBranchNotFound: 'Customer or branch not found!',
                    productsNotFound: 'Products not found!',
                    dataLoadError: 'Error loading data: {{message}}',
                    errorOccurred: 'An error occurred',
                    unknownError: 'Unknown error',
                    refreshPage: 'Refresh page',
                    previous: 'Previous',

                    paymentMethods: 'Payment methods',
                    paymentMethod: 'Payment method',
                    payOfflineLabel: '1. Cash payment',
                    payOfflineDesc: 'Pay to the courier or at checkout',
                    payWithClickLabel: '2. Pay via Click',
                    payWithClickDesc: 'Online payment (CLICK)',
                    payOffline: 'Cash payment',
                    payWithClick: 'Pay with Click',



                }
            }
        }
    });

export default i18n;
